import { BarChart3 } from '@/lib/icons'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export interface ViewsSourceSectionProps {
  /** Server qiymati — v1'da amalda har doim `'manual'`, lekin `SettingsResponse.viewsProvider`
   * tipi qat'iy `'manual'` bilan cheklanmagan (`string`), shuning uchun boshqa qiymat kelsa
   * ham ekran yiqilmasligi kerak (pastdagi izohga qarang). */
  value: string
  onChange: (value: string) => void
  disabled: boolean
}

/**
 * "📊 Prosmotr manbai" bo'limi — `docs/03-app-flow.md` maketi radio tugmalarini ko'rsatadi,
 * lekin faqat "Qo'lda kiritish" TANLASH mumkin. "Avtomatik (v2)" ataylab `disabled`:
 * topshiriq talabi shu ("keyingi versiyada" izohi bilan) — Instagram'ni avtomatik skrap
 * qilish hali qurilmagan (`lib/config.ts`dagi `hiker`/`scrapecreators` provayderlar bor,
 * lekin bu ekrandan ULARNI YOQIB BO'LMAYDI, faqat kelajakdagi imkoniyat sifatida ko'rsatiladi).
 */
export function ViewsSourceSection({ value, onChange, disabled }: ViewsSourceSectionProps) {
  const isManual = value === 'manual'

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <BarChart3 size={16} aria-hidden="true" /> Prosmotr manbai
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <label
          className={cn(
            'flex cursor-pointer items-center gap-3 rounded-button px-2 py-2',
            disabled && 'cursor-not-allowed opacity-60',
          )}
        >
          <input
            type="radio"
            name="views-provider"
            checked={isManual}
            disabled={disabled}
            onChange={() => onChange('manual')}
            className="size-4 accent-brand"
          />
          <span className="text-sm text-app-text">Qo&apos;lda kiritish</span>
        </label>

        <label className="flex cursor-not-allowed items-start gap-3 rounded-button px-2 py-2 opacity-60">
          <input
            type="radio"
            name="views-provider"
            checked={!isManual}
            disabled
            readOnly
            className="mt-0.5 size-4 accent-brand"
          />
          <span className="flex flex-col">
            <span className="text-sm text-app-text">Avtomatik (v2)</span>
            <span className="text-xs text-app-hint">
              Keyingi versiyada qo&apos;llab-quvvatlanadi.
            </span>
          </span>
        </label>
      </CardContent>
    </Card>
  )
}
